import {
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  Icon,
} from "@chakra-ui/react";
import React from "react";

/**
 * Renders the secondary card
 * 
 * @param {Object} props The props of the component
 * @returns The secondary card
 */
const SecondaryCard = ({ children, title, icon, badge, ...props }) => (
  <Card variant={"secondary"} zIndex={1000} {...props}>
    {title ? (
      <CardHeader>
        <HStack>
          <Icon as={icon} boxSize={3} />
          <Heading fontSize={"md"}>{title}</Heading>
          {badge}
        </HStack>
      </CardHeader>
    ) : null}
    <CardBody>{children}</CardBody>
  </Card>
);

export default React.memo(SecondaryCard);
